<template>
<div style="height: 100%">
    <div id="evolve">Evolve</div>
    <div class="row" id="content">
        <div class="col d-flex flex-row align-items-center">
            <div id="form">
                <form @submit.prevent="sendMail">
                    <div class="row">
                        <h1 id="title">Forgot Password</h1>
                    </div>
                    <div class="form-group">
                        <input name="email" id="email" placeholder="EMAIL" v-model="email" class="form-control">         
                    </div>
                    <div class="d-flex flex-column" >
                    <div> 
                        <p v-if="feedback" class="feedback">{{feedback}}</p>
                        <button type="button" class="forgot-btn btn-primary" @click="toLogin">Return to Login</button>
                        <button type="submit" class="forgot-btn btn-primary">Submit</button>
                    </div>
                    </div>
                </form> 
            </div>
        </div>
    </div>
</div>
</template>
<script>
import firebase from '@/firebase/init'
export default {
    name: 'ForgotPassword',
    data(){
        return{
            email: null,
            feedback: null
        }
    },
    methods:{
        sendMail(){
            var thisRef = this
            if(this.email){
            var auth = firebase.auth();

            auth.sendPasswordResetEmail(this.email).then(function() {
                thisRef.feedback = "We've sent you an email with a link to reset your password"
            }).catch(function(error) {
                console.log(error.code)
                if(error.code == 'auth/user-not-found'){
                    thisRef.feedback = "There is no user with this email"
                }
                else{
                    thisRef.feedback = error.message
                }
            });
            }
            else{
                this.feedback = "You must enter email"
            }
        },
        toLogin(){
            this.$router.push({name: 'Login'})
        }
    },
    beforeCreate: function() {
            document.body.className = 'signup'
            this.$parent.showNavbar = false        
    }
}
</script>
<style>
.feedback{
    color: red;
}
#evolve{
    font-family: GothamRndSSm-Light;
    font-size: 22px;
    color: black;
    margin: 0 0 0 5em;
    height: 5%;
    text-align: start;
    bottom: 0;
    text-anchor: end;
    padding-top: 3em;
}
.form-control{
    border-color: black;
    height: 3.5em;
    margin-top: 1.5em;
    padding-left: 1.5em;
    border-radius: 0.5em;
    line-height: normal;
    line-height: 32px;
}
.forgot-btn{
    font-size: 0.7em !important;
    height: 5em;
    width: 47.5% !important;
    right: 0;
    margin-top: 1.5em;
    float: left;
    background-color: #5D38DB;
    border-radius: 0.5em;
    line-height: inherit;
    margin-right: 1em;
}
::placeholder {
  color: black !important;
  font-family: GothamRndSSm-Book;
  font-size: 10px !important;

}
#form{
    width: 30em;
    margin-left: 10em;
}
#title{
    color: black;
    font-size: 40px;
    font-family: GothamRndSSm-Light;
}
p{
    margin-top: 1.5em;
    margin-bottom: 3em;
}
.row h1{
    margin-left: 0.5em;
    margin-bottom: 0.8em;
}
.bottomline p{
    margin-left: 1em;
    font-weight: 500;
    font-size: 12px;
    margin-top: 1.5em;
    margin-bottom: 3em;
    color: black;
    font-family: GothamRndSSm-Book;
}
#content{
    height: 90%;
    margin-left: 0;
    margin-right: 0;
}
@media (max-width: 700px) {
    #evolve{
        margin-left: 3em;
    }
    #form{
        margin-left: 2em;
    }
}
@media (max-width: 600px) {
    #evolve{
        padding-top: 0;
        margin-top: 2em;
        margin-left: 1em;
    }
    #form{
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue